import { useMemo } from 'react';
import { useDynamicInvoice } from '../dynamic-invoice-context';

/**
 * Hook to extract commonly used IDs from the dynamic invoice context.
 * Memoizes the values to prevent unnecessary re-renders.
 *
 * @returns Object containing invoiceId, customerId, and reviewStatus
 */
export function useDynamicInvoiceIds() {
  const { dynamicInvoiceData } = useDynamicInvoice();

  return useMemo(
    () => ({
      invoiceId: dynamicInvoiceData.invoice.id,
      customerId: dynamicInvoiceData.customer.id,
      reviewStatus: dynamicInvoiceData.invoice.reviewStatus,
    }),
    [dynamicInvoiceData.invoice.id, dynamicInvoiceData.customer.id, dynamicInvoiceData.invoice.reviewStatus],
  );
}
